import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import http from '../helpers/http';

type OrgsT = {
  [k: string]: string;
};

const useGetOrganization = () => {
  const axios = useMemo(() => http(), []);

  const getOrgs = async () => {
    const { data } = await axios.get<OrgsT>(
      'https://auth0-organizations.s3.amazonaws.com/orgs.json',
    );
    return data;
  };

  return useQuery<OrgsT | undefined, AxiosError>(['organizations'], getOrgs, {
    retry: false,
    staleTime: 86400 * 1000,
  });
};

export default useGetOrganization;
